<template>
  <div v-show="isLoaded" class="mCategory_container" v-observe-visibility="startAnimate">
    <img class="mCategory_img" :src="banner_category" alt="Banner categoría">
    <h2 class="mCategory_title" :class="{animate: animate}">Categorías Oficiales</h2>
    <h3 class="mCategory_subtitle" :class="{animate: animate}">Categorías Varonil y Femenil</h3>
    <div class="mCategory_row">
        <div class="mCategory_left">
            <div>
                <h4 class="mCategory_number_two" :class="{animate: animate}">2</h4>
                <h4 class="mCategory_two" :class="{animate: animate}">Segunda categoría</h4>
            </div>
            <div>
                <h4 class="mCategory_number_thee" :class="{animate: animate}">3</h4>
                <h4 class="mCategory_thee" :class="{animate: animate}">Tercera categoría</h4>
            </div>
            <div>
                <h4 class="mCategory_number_four" :class="{animate: animate}">4</h4>
                <h4 class="mCategory_four" :class="{animate: animate}">Cuarta categoría</h4>
            </div>
            <!-- <img class="mCategory_img_one" :src="category_men" alt="Categoría varonil"> -->
        </div>
        <div class="mCategory_right">
            <div>
                <h4 class="mCategory_number_five" :class="{animate: animate}">5</h4>
                <h4 class="mCategory_five" :class="{animate: animate}">Quinta categoría</h4>
            </div>
            <div>
                <h4 class="mCategory_number_six" :class="{animate: animate}">6</h4>
                <h4 class="mCategory_six" :class="{animate: animate}">Sexta categoría</h4>
            </div>
            <!-- <img class="mCategory_img_two" :src="category_women" alt="Categoría femenil"> -->
        </div>
        <!-- <img class="mCategory_logo" :src="logo" alt="Banner MPT"> -->
    </div>
  </div>
</template>

<script>
import banner_category from "@/assets/home/category_two.jpeg";
import logo from "@/assets/logo_MPT.png";
import category_men from "@/assets/category_men.png";
import category_women from "@/assets/category_women.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "Category",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner_category,
            logo,
            category_men,
            category_women,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Category.scss";
</style>